module.exports = __webpack_public_path__ + "static/reindeer-sparkles-ae7773da746eb61dcf85a77e16a00063.gif";